<div class="cat__pages__impersonation cat__pages__impersonation--fullscreen">
    <div class="cat__pages__impersonation__block cat__pages__impersonation__block--extended">
        <div class="row">
            <div class="col-xl-12">
                <div class="cat__pages__impersonation__block__inner">
                    <div class="cat__pages__impersonation__block__form">
                        <h4 class="">
                            <div class="impersonation-logo"></div>
                            <br/><br/>
                            <strong>You are not registered for any events.</strong>
                        </h4>
                        <a href="https://bloodcancerunited.org/get-involved/fundraise" target="_blank"
                           class="text-primary">Learn more</a> about how you can participate today!
                        <br/>
                        <br/>
                        <button type="button" class="btn btn-primary" (click)="logout()">Logout</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>